var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSwiperNaviLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10Z",
    stroke: "#CCCCCC",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20711 10L11.8536 7.73162C12.0488 7.56425 12.0488 7.29289 11.8536 7.12553C11.6583 6.95816 11.3417 6.95816 11.1464 7.12553L8.14645 9.69695C7.95118 9.86432 7.95118 10.1357 8.14645 10.303L11.1464 12.8745C11.3417 13.0418 11.6583 13.0418 11.8536 12.8745C12.0488 12.7071 12.0488 12.4358 11.8536 12.2684L9.20711 10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_339_3341",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 4,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20711 10L11.8536 7.73162C12.0488 7.56425 12.0488 7.29289 11.8536 7.12553C11.6583 6.95816 11.3417 6.95816 11.1464 7.12553L8.14645 9.69695C7.95118 9.86432 7.95118 10.1357 8.14645 10.303L11.1464 12.8745C11.3417 13.0418 11.6583 13.0418 11.8536 12.8745C12.0488 12.7071 12.0488 12.4358 11.8536 12.2684L9.20711 10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_339_3341)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSwiperNaviLeft);
export default __webpack_public_path__ + "static/media/ico-swiper-navi-left.9e70ba609bda0fd8deb6628d05964818.svg";
export { ForwardRef as ReactComponent };